import { ShopperAiFlagKey } from "@redotech/feature-flags-keys-shopper-ai/keys";
import type { FeatureFlagKey } from "@redotech/feature-flags-model/keys";
import { TeamContext } from "@redotech/redo-web/context/team-context";
import { useContext } from "react";

function getTeamFeatureFlags(
  team: unknown,
): Partial<Record<FeatureFlagKey, boolean>> | undefined {
  return (team as { featureFlags?: unknown } | null | undefined)
    ?.featureFlags as Partial<Record<FeatureFlagKey, boolean>> | undefined;
}

/**
 * Returns true once team data has loaded. Reclaim setup-guide is always on;
 * Shopper Agent is still gated separately via useShopperAgentEnabled.
 */
export function useAnySetupGuideProductEnabled(): boolean {
  const team = useContext(TeamContext);
  return team != null;
}

export function useShopperAgentEnabled(): boolean {
  const team = useContext(TeamContext);
  if (!team) {
    return false;
  }
  return getTeamFeatureFlags(team)?.[ShopperAiFlagKey.SHOPPER_AGENT] === true;
}
